import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICase } from '../../models/case.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class CaseApiService {

  abstract saveCase(incident: ICase, program: string, name: string): Observable<any>;

}
